export default __webpack_public_path__ + "static/media/slopeSurfaceMorphology.8b31b9d9.png";